import { FadeUp } from "./Reveal";

const steps = [
  {
    n: "01",
    title: "Discover & Define",
    body: "We analyze your firm's specific workflows, platforms, and reporting style.",
  },
  {
    n: "02",
    title: "Source & Train",
    body: "We place dedicated specialists trained to your exact standards, managed directly from India.",
  },
  {
    n: "03",
    title: "Seamless Integration",
    body: "They work exclusively for your practice as a direct extension of your internal team.",
  },
  {
    n: "04",
    title: "Quality & Oversight",
    body: "You review output while we handle HR, ongoing management, and technical support.",
  },
];

export const Process = () => (
  <section id="process" className="py-24 md:py-36 relative z-10" data-testid="process-section">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16">
        <div className="md:col-span-4">
          <span className="font-sans text-xs uppercase tracking-[0.28em] text-verdigris">
            How It Works
          </span>
          <FadeUp>
            <h2 className="font-serif text-petrol text-4xl md:text-5xl tracking-tight mt-8 leading-[1.05] md:sticky md:top-32">
              A calm, four-step path to added capacity.
            </h2>
          </FadeUp>
        </div>

        <div className="md:col-span-8">
          <div className="border-t border-petrol/20">
            {steps.map((s, i) => (
              <FadeUp
                key={s.n}
                delay={i * 0.08}
                className="group grid grid-cols-12 gap-4 md:gap-8 items-baseline py-8 md:py-12 border-b border-petrol/20 hover:bg-parchment-dark/60 transition-colors px-2"
                data-testid={`process-step-${i + 1}`}
              >
                <span className="col-span-2 font-serif text-4xl md:text-6xl text-verdigris">
                  {s.n}
                </span>
                <div className="col-span-10">
                  <h3 className="font-serif text-2xl md:text-4xl text-petrol mb-3 group-hover:translate-x-2 transition-transform duration-500">
                    {s.title}
                  </h3>
                  <p className="font-sans text-petrol/70 text-base md:text-lg leading-relaxed max-w-xl">
                    {s.body}
                  </p>
                </div>
              </FadeUp>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);
